import styled from "styled-components";

export const ContentTable = styled.div`
  background-color: white;
  overflow: auto;
  width: 100%;
  padding: 0;

  .dossierDescription {
    max-width: 9.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.2rem;

    @media (max-width: 600px) {
      max-width: 6rem;
      font-size: 1rem;
    }
  }

  .buttonError {
    border: none;
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;
  }

  @media (max-width: 600px) {
    white-space: nowrap;

    table {
      font-size: 0.9rem;

      th,
      td {
        padding: 8px 4px;
      }

      .MuiButton-root {
        font-size: 0.8rem;
        padding: 4px 8px;
      }

      .MuiChip-root {
        font-size: 0.75rem;
        height: 24px;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 900px) {
    white-space: nowrap;

    table {
      font-size: 1rem;

      th,
      td {
        padding: 10px 6px;
      }
    }
  }
`;
